import React from 'react';
import Page from '../../components/Page';
import { MainPageDetails } from '../../sections/client-zs/MainPageDetails';

const MainPage = () => (
  <Page title="Strona Główna">
    <MainPageDetails />
  </Page>
);

export default MainPage;
